import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Dialog, FormControl, Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  getQuestionTags,
  getCodingQuestionByID,
  getCodingQuestionReturnTypes,
  getQuestionLevels,
  postUpdateCodingQuestion,
  resetCodingQuestionById,
  getCodingQuestionDataTypes,
  generateCodingStub,
  postCreateCodingQuestionv2,
  getCodingQuestionLanguagesv2,
  clearCreateQuestionState,
} from "../../Redux/ActionCreators/testLibraryAction";
import JoditEditor from "jodit-react";
import { returnErrors } from "../../Redux/ActionCreators/errorAction";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import {
  emptyTopics,
  getSkills,
  getSkillTopics,
} from "../../Redux/ActionCreators/myTestsAction";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./style.scss";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/ace";
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/src-noconflict/theme-chaos";
import "ace-builds/src-noconflict/ext-language_tools.js";
import "ace-builds/src-noconflict/theme-idle_fingers";
import "ace-builds/src-noconflict/mode-python";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/worker-html";
import "ace-builds/src-noconflict/worker-javascript";
import ace from "ace-builds/src-noconflict/ace";

ace.config.set("basePath", "/node_modules/ace-builds/src-noconflict");

const UI_STRINGS = {
  TIME: "time",
  DIFFICULTY: "difficulty",
};

const save_button_style = {
  backgroundColor: "var(--button-color)",
  color: "#fff",
  borderRadius: "12px",
  height: 48,
  border: "none",
  fontSize: 14,
  padding: "10px 30px",
  minWidth: 150,
  marginBottom: 50,
};

const CreateCodingQuestionv2 = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const isEmbedded = props?.embedded || props?.fromCreateQuestion || false;
  const currentEditMode = isEmbedded ? props?.editMode : location?.state?.edit;
  const currentViewMode = isEmbedded ? props?.viewMode : location?.state?.view;
  const isCreateMode = !currentEditMode && !currentViewMode;
  const details = JSON.parse(localStorage.getItem("profileDetails"));
  const isViewMode = currentViewMode === true;
  const currentDetail = isEmbedded
    ? props?.existingDetail
    : location?.state?.detail;
  const currentType = isEmbedded
    ? props?.questionTypeID
    : Number(location?.state?.questionTypeID) ||
      (currentDetail?.questionTypeID ?? null);

  const descriptionEditorRef = useRef(null);
  const solutionMenuRef = useRef(null);
  const testCaseMenuRef = useRef(null);
  const stubHeadRef = useRef("");
  const stubBodyRef = useRef("");
  const stubTailRef = useRef("");
  const solutionEditorRef = useRef("");
  const tcInputRef = useRef(null);
  const tcOutputRef = useRef(null);

  const {
    questionLevel,
    qTags,
    codingQuestionLanguagesOptions,
    loadingCodingQuestionById,
    codingQuestionByIdResponse,
    codingQuestionDataTypesOptions,
  } = useSelector((state) => state.testLibrary);
  const { skills, topics } = useSelector((state) => state.myTests);

  const [questionTitle, setQuestionTitle] = useState("");
  const [questionDescription, setQuestionDescription] = useState("");
  const [questionDescriptionError, setQuestionDescriptionError] = useState("");

  const [programmingLanguages, setProgrammingLanguages] = useState([]);
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);

  const [questionWeightage, setQuestionWeightage] = useState(20);

  const [timeDuration, setTimeDuration] = useState(10);
  const [selectedKnowledgeArea, setSelectedKnowledgeArea] = useState(null);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [selectDifficulty, setSelectDifficulty] = useState(1);
  const [selectOutput, setSelectOutput] = useState(1);
  const [resolvedType, setResolvedType] = useState(null);
  const [stubConfig, setStubConfig] = useState({
    function_name: "",
    function_return_type: null,
    function_params: [],
    stubs: [],
  });
  const [sampleSolutions, setSampleSolutions] = useState([]);
  const [testCasesV2, setTestCasesV2] = useState([]);
  const [openStubModal, setOpenStubModal] = useState(false);
  const [openSolutionModal, setOpenSolutionModal] = useState(false);
  const [openTestcaseModal, setOpenTestcaseModal] = useState(false);
  const [solutionLanguage, setSolutionLanguage] = useState(null);
  const [tcInput, setTcInput] = useState("");
  const [tcOutput, setTcOutput] = useState("");
  const [tcWeight, setTcWeight] = useState(1);
  const [tcIsSample, setTcIsSample] = useState(false);
  const [stubs, setStubs] = useState([]);
  const [stubLanguage, setStubLanguage] = useState(null);
  const [stubHead, setStubHead] = useState("");
  const [stubBody, setStubBody] = useState("");
  const [stubTail, setStubTail] = useState("");
  const [solutionEditIndex, setSolutionEditIndex] = useState(null);
  const [tcEditIndex, setTcEditIndex] = useState(null);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [openTestCaseIndex, setOpenTestCaseIndex] = useState(null);
  const [isGeneratingStub, setIsGeneratingStub] = useState(false);
  const [isStubInitialized, setIsStubInitialized] = useState(false);
  const [stubEditorVersion, setStubEditorVersion] = useState(0);
  const [stubReady, setStubReady] = useState(false);
  const [solutionEditorVersion, setSolutionEditorVersion] = useState(0);

  const joditConfig = {
    toolbarInlineForSelection: true,
    toolbar: true,
    readonly: isViewMode,
    statusbar: false,
    showCharsCounter: false,
    showWordsCounter: false,
    height: 150,
    askBeforePasteFromWord: false,
    askBeforePasteHTML: false,
    defaultActionOnPaste: "insert_clear_html",
    defaultActionOnPasteFromWord: "insert_as_html",
    enableDragAndDropFileToEditor: true,
    removeButtons: ["eraser", "fullsize"],
  };

  const ACE_MODE_MAP = {
    python: "python",
    javascript: "javascript",
    typescript: "typescript",
    java: "java",
    cpp: "c_cpp",
    c: "c_cpp",
    csharp: "csharp",
    go: "golang",
    ruby: "ruby",
    php: "php",
  };

  const aceMode = useMemo(() => {
    return ACE_MODE_MAP[String(stubLanguage)?.toLowerCase()] || "text";
  }, [stubLanguage]);

  const StubAceEditor = ({
    defaultValue,
    onChange,
    readOnly,
    mode,
    height,
  }) => (
    <AceEditor
      // mode={mode}
      mode="html"
      theme="github"
      defaultValue={defaultValue}
      onChange={onChange}
      width="100%"
      height={height}
      fontSize={14}
      showPrintMargin={false}
      readOnly={readOnly}
      setOptions={{
        useWorker: false,
        showLineNumbers: true,
        tabSize: 2,
      }}
    />
  );

  const codingLanguages = codingQuestionLanguagesOptions || [];

  useEffect(() => {
    dispatch(getQuestionTags());
  }, []);

  useEffect(() => {
    const fetchQuestion = async () => {
      if (location?.state?.detail?.id) {
        await dispatch(resetCodingQuestionById());
        setTimeout(async () => {
          await dispatch(getCodingQuestionByID(location.state.detail.id));
        }, 0);
      }
    };
    fetchQuestion();

    dispatch(getCodingQuestionLanguagesv2());
    dispatch(getCodingQuestionReturnTypes);
    dispatch(getCodingQuestionDataTypes());
    dispatch(getQuestionLevels());
  }, []);

  useEffect(() => {
    const type =
      props?.questionTypeID ??
      location?.state?.questionTypeID ??
      currentDetail?.questionTypeID;

    setResolvedType(Number(type));
  }, []);

  useEffect(() => {
    if (!skills || skills.length === 0) {
      const details = JSON.parse(localStorage.getItem("profileDetails"));
      details?.tenentId === "-1" && details?.roleId === "1"
        ? dispatch(getSkills(1))
        : dispatch(getSkills(2));
    }
  }, []);

  useEffect(() => {
    if (!codingQuestionByIdResponse?.question) return;

    const q = codingQuestionByIdResponse.question;

    setQuestionTitle(q.name || "");
    setQuestionDescription(q.description || "");
    setTimeDuration(q.duration || 10);
    setQuestionWeightage(q.weightage || 20);
    setSelectDifficulty(q.difficultyLevelId || 1);
    setSelectOutput(q.outputReturnTypeId || 1);

    setProgrammingLanguages(
      q.languages?.map((l) => ({
        label: l.displayLanguage,
        value: l.codingLanguageId,
      })) || [],
    );

    setTags(q.tags?.map((t) => ({ label: t, value: t })) || []);

    setSelectedKnowledgeArea({
      label: q.skillName,
      value: q.skillId,
    });

    setSelectedTopic({
      label: q.skillTopicName,
      value: q.skillTopicId,
    });

    let parsedData = null;

    try {
      parsedData = q?.data ? JSON.parse(q.data) : null;
    } catch (e) {
      console.error("Invalid coding question data JSON", e);
    }

    if (!parsedData) return;

    setStubConfig({
      function_name: parsedData.function_name || "",
      function_return_type: parsedData.function_return_type ?? null,
      function_params: parsedData.function_params || [],
      stubs: parsedData.stubs || [],
    });

    setStubs(parsedData.stubs || []);

    if (!isStubInitialized && parsedData?.stubs?.length > 0) {
      const s = parsedData.stubs[0];

      setStubLanguage(s.language);
      setStubHead(s.head || "");
      setStubBody(s.body || "");
      setStubTail(s.tail || "");

      setIsStubInitialized(true);
    }

    setSampleSolutions(
      (parsedData.solutions || []).map((s) => {
        const matchedLang = codingQuestionLanguagesOptions?.find(
          (l) =>
            l.displayLanguage === s.language || l.codingLanguage === s.language,
        );

        return {
          language_label: s.language,
          language_id: matchedLang?.id || null,
          solution: s.solution || "",
        };
      }),
    );

    setTestCasesV2(parsedData.test_cases || []);
  }, [
    codingQuestionByIdResponse,
    codingQuestionLanguagesOptions,
    isStubInitialized,
  ]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        solutionMenuRef.current &&
        !solutionMenuRef.current.contains(event.target)
      ) {
        setOpenMenuIndex(null);
      }

      if (
        testCaseMenuRef.current &&
        !testCaseMenuRef.current.contains(event.target)
      ) {
        setOpenTestCaseIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (openTestcaseModal) {
      requestAnimationFrame(() => {
        tcInputRef.current && autoResize(tcInputRef.current);
        tcOutputRef.current && autoResize(tcOutputRef.current);
      });
    }
  }, [openTestcaseModal]);

  useEffect(() => {
    if (!location?.state?.edit && !location?.state?.view) {
      dispatch(clearCreateQuestionState());
    }
  }, []);

  const handleSelectChange = (select_name, event) => {
    if (select_name === UI_STRINGS.OUTPUT) {
      setSelectOutput(event?.target?.value);
    }
    if (select_name === UI_STRINGS.DIFFICULTY) {
      setSelectDifficulty(event?.target?.value);
    }
  };

  const handleKnowledgeAreaChange = async (selectedArea) => {
    setSelectedKnowledgeArea(selectedArea);
    setSelectedTopic(null);

    if (!selectedArea) {
      dispatch(emptyTopics());
      return;
    }

    if (selectedArea.__isNew__) {
      dispatch(emptyTopics());
      return;
    }

    try {
      setLoading(true);
      const details = JSON.parse(localStorage.getItem("profileDetails"));
      if (details?.tenentId === "-1" && details?.roleId === "1") {
        await dispatch(getSkillTopics(selectedArea.value));
      } else {
        await dispatch(getSkillTopics(2, selectedArea.value));
      }
    } catch (err) {
      console.error("Failed to load topics for Knowledge Area", err);
    } finally {
      setLoading(false);
    }
  };

  const handleTags = (e) => {
    console.log(e);
    setTags(e);
  };

  const validateForm = () => {
    if (!questionTitle) {
      returnErrors(dispatch, "Question name is required!", 500);
      return false;
    } else if (!questionDescription) {
      returnErrors(dispatch, "Question description is required!", 500);
      return false;
    } else if (!timeDuration) {
      returnErrors(dispatch, "Question duration is required!", 500);
      return false;
    } else if (!selectDifficulty) {
      returnErrors(dispatch, "Question difficulty is required!", 500);
      return false;
    } else if (!questionWeightage) {
      returnErrors(dispatch, "Question score is required!", 500);
      return false;
    } else if (programmingLanguages?.length === 0 && currentType !== 13) {
      returnErrors(
        dispatch,
        "At least 1 programming language is required!",
        500,
      );
      return false;
    } else if (tags?.length === 0) {
      returnErrors(dispatch, "At least 1 tag is required!", 500);
      return false;
    } else if (!selectedKnowledgeArea) {
      returnErrors(dispatch, "Please select a Knowledge Area!", 500);
      return false;
    } else if (!selectedTopic) {
      returnErrors(dispatch, "Please select a Topic!", 500);
      return false;
    } else if (!stubs || stubs.length === 0) {
      returnErrors(dispatch, "Please add at least one code stub!", 500);
      return false;
    } else if (!testCasesV2 || testCasesV2.length === 0) {
      returnErrors(dispatch, "Please add at least one test case!", 500);
      return false;
    }

    return true;
  };

  const questionSaveHandler = async () => {
    await setLoading(true);
    const is_formValid = validateForm();
    if (is_formValid) {
      const dataPayload = {
        function_name: stubConfig.function_name,
        function_return_type: stubConfig.function_return_type,
        function_params: stubConfig.function_params,

        stubs: stubs.map((s) => ({
          language: s.language,
          head: s.head,
          body: s.body,
          tail: s.tail,
        })),

        solutions: sampleSolutions.map((s) => ({
          language: s.language_label,
          solution: s.solution,
        })),

        test_cases: testCasesV2.map((t) => ({
          name: t.name,
          input: t.input,
          output: t.output,
          is_sample: t.is_sample,
          weight: t.weight,
        })),
      };

      let request_data;
      request_data = {
        tenantId: parseInt(details?.tenentId),
        questionTypeID: currentType,
        name: questionTitle,
        description: questionDescription,
        outputReturnTypeId: selectOutput,
        duration: timeDuration,
        difficultyLevelId: selectDifficulty,
        weightage: questionWeightage,
        languages: programmingLanguages.map(
          (el) => [{ codingLanguageId: el.value }][0],
        ),
        tags: tags.map((el) => el.value),
        addFromList: props.addFromList ? true : null,
        skillId: selectedKnowledgeArea?.value || 0,
        skillTopicId: selectedTopic?.value || 0,
        skillName: selectedKnowledgeArea?.label || "",
        skillTopicName: selectedTopic?.label || "",
        data: JSON.stringify(dataPayload),
      };
      if (location?.state?.edit) {
        request_data.id = location?.state?.detail?.id;
        const response = await dispatch(
          postUpdateCodingQuestion({
            ...request_data,
            id: location.state.detail?.id,
          }),
        );
        if (response.type === "UPDATE_CODING_QUESTION") {
          navigate(-1);
          return response;
        }
      } else {
        const response = await dispatch(
          postCreateCodingQuestionv2(request_data),
        );
        if (response?.type === "CREATE_CODING_QUESTION") {
          props.addFromList ? props.goBack() : navigate(-1);
          return response;
        }
      }
    }
    await setLoading(false);
  };

  const handleSaveAndTry = async () => {
    let res;
    try {
      res = await questionSaveHandler();
    } catch (err) {
      console.error(" questionSaveHandler threw error:", err);
      return;
    }

    const id = res?.payload?.question?.id || res?.payload?.id || res?.payload?.questionID;
    if (!id) {
      return;
    }

    const url = `/try-coding/${id}`;
    window.open(url, "_blank");
  };


  const handleOpenStubModal = () => {
    const existing = stubs?.[0];

    stubHeadRef.current = existing?.head || "";
    stubBodyRef.current = existing?.body || "";
    stubTailRef.current = existing?.tail || "";

    setOpenStubModal(true);
  };

  const saveStub = () => {
    setStubs([
      {
        language: stubLanguage,
        head: stubHeadRef.current,
        body: stubBodyRef.current,
        tail: stubTailRef.current,
      },
    ]);

    setOpenStubModal(false);
  };

  const openAddSolution = () => {
    solutionEditorRef.current = "";
    setSolutionEditIndex(null);
    setSolutionEditorVersion((v) => v + 1);
    setOpenSolutionModal(true);
  };

  const openEditSolution = (item, index) => {
    setSolutionLanguage({
      label: item.language_label,
      value: item.language_id,
    });

    solutionEditorRef.current = item.solution || "";
    setSolutionEditIndex(index);
    setSolutionEditorVersion((v) => v + 1);
    setOpenSolutionModal(true);
  };

  const saveSolution = () => {
    const payload = {
      language_id: solutionLanguage?.value,
      language_label: solutionLanguage?.label,
      solution: solutionEditorRef.current,
    };

    if (solutionEditIndex !== null) {
      const copy = [...sampleSolutions];
      copy[solutionEditIndex] = payload;
      setSampleSolutions(copy);
    } else {
      setSampleSolutions([...sampleSolutions, payload]);
    }

    setOpenSolutionModal(false);
  };

  const openAddTestcase = () => {
    setTcInput("");
    setTcOutput("");
    setTcWeight(1);
    setTcIsSample(false);
    setTcEditIndex(null);
    setOpenTestcaseModal(true);
  };

  const openEditTestcase = (t, index) => {
    setTcInput(t.input);
    setTcOutput(t.output);
    setTcWeight(t.weight);
    setTcIsSample(t.is_sample);
    setTcEditIndex(index);
    setOpenTestcaseModal(true);
  };

  const saveTestcase = () => {
    if (tcIsSample) {
      const alreadyHasSample = testCasesV2.some(
        (t, idx) => t.is_sample && idx !== tcEditIndex,
      );

      if (alreadyHasSample) {
        returnErrors(dispatch, "Only one sample testcase is allowed!", 500);
        return;
      }
    }

    const obj = {
      name:
        tcEditIndex !== null
          ? testCasesV2[tcEditIndex].name
          : `TestCase #${testCasesV2.length + 1}`,
      input: tcInput,
      output: tcOutput,
      is_sample: tcIsSample,
      weight: tcWeight,
    };

    if (tcEditIndex !== null) {
      const copy = [...testCasesV2];
      copy[tcEditIndex] = obj;
      setTestCasesV2(copy);
    } else {
      setTestCasesV2([...testCasesV2, obj]);
    }

    setOpenTestcaseModal(false);
  };

  const handleGenerateStub = async () => {
    if (!stubLanguage) {
      returnErrors(dispatch, "Please select a programming language!", 500);
      return;
    }

    if (!stubConfig.function_name?.trim()) {
      returnErrors(dispatch, "Please enter a function name!", 500);
      return;
    }

    if (!stubConfig.function_return_type) {
      returnErrors(dispatch, "Please select a return type!", 500);
      return;
    }

    if (
      !stubConfig.function_params ||
      stubConfig.function_params.length === 0
    ) {
      returnErrors(
        dispatch,
        "Please add at least one function parameter!",
        500,
      );
      return;
    }

    const hasInvalidParam = stubConfig.function_params.some(
      (p) => !p.name?.trim() || !p.data_type,
    );
    if (hasInvalidParam) {
      returnErrors(
        dispatch,
        "Each function parameter must have a name and type!",
        500,
      );
      return;
    }

    const allowedProgrammingLanguages = codingLanguages
      .filter((l) => l.category?.id === 1)
      .map((l) => l.codingLanguage)
      .filter(Boolean);

    const payload = {
      allowedProgrammingLanguages,
      stubGeneratorData: {
        functionName: stubConfig.function_name,
        functionReturnType: stubConfig.function_return_type,
        functionParams: stubConfig.function_params.map((p) => ({
          name: p.name,
          type: p.data_type,
          pattern: 0,
        })),
        language: stubLanguage,
      },
    };

    try {
      setIsGeneratingStub(true);

      const res = await dispatch(generateCodingStub(payload));

      console.log("🟢 generateCodingStub raw response:", res);

      const stub = res?.payload?.stubs?.[0];

      if (!stub) {
        console.error("❌ No stub found");
        return;
      }

      console.log("🧠 extracted stub:", stub);

      setStubReady(false);

      stubHeadRef.current = stub.head || "";
      stubBodyRef.current = stub.body || "";
      stubTailRef.current = stub.tail || "";

      setStubEditorVersion((v) => v + 1);

      setStubReady(true);
    } catch (err) {
      console.error("Stub generation failed", err);
    } finally {
      setIsGeneratingStub(false);
    }
  };

  const autoResize = (el) => {
    if (!el) return;
    el.style.height = "28px";
    el.style.height = el.scrollHeight + "px";
  };

  const handleBack = async () => {
    await dispatch(clearCreateQuestionState());
    navigate(-1);
  };

  return (
    <div>
      <div
        className={
          isEmbedded
            ? ""
            : "bg-white rounded m-3 px-5 py-3 create-question-main"
        }
      >
        {!isEmbedded && (
          <>
            <div>
              <div className="d-flex">
                <img
                  src="/images/back.svg"
                  alt=""
                  className="cursor-pointer"
                  onClick={handleBack}
                />
                &nbsp;&nbsp;
                <h1 className="maintxt">
                  {" "}
                  {location?.state?.view
                    ? "View Question"
                    : location?.state?.edit
                      ? "Edit Question"
                      : "Create Question"}
                </h1>
              </div>
            </div>
            <br />
          </>
        )}
        <div className="row mt-4">
          <div className="col-md-6 col-12">
            <Stack spacing={2}>
              <div>
                <label className="labeltext px-0">Knowledge Area*</label>
              </div>
              <div className="mt-2">
                <CreatableSelect
                  isClearable
                  placeholder="Select Knowledge Area"
                  options={
                    skills?.map((el) => ({
                      label: el.label || el.knowledgeAreaName || el.skillName,
                      value: el.value || el.knowledgeAreaId || el.skillId,
                    })) || []
                  }
                  value={selectedKnowledgeArea}
                  onChange={(e) => handleKnowledgeAreaChange(e)}
                  onCreateOption={(inputValue) => {
                    const newKA = {
                      label: inputValue,
                      value: 0,
                      __isNew__: true,
                    };

                    setSelectedKnowledgeArea(newKA);
                    setSelectedTopic(null);
                    dispatch(emptyTopics());
                  }}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  isDisabled={isViewMode}
                />
              </div>
            </Stack>
          </div>
          <div className="col-md-6 col-12">
            <Stack spacing={2}>
              <div>
                <label className="labeltext px-0">Topics*</label>
              </div>
              <div className="mt-2">
                <CreatableSelect
                  isClearable
                  placeholder="Select Topic"
                  options={
                    topics?.map((el) => ({
                      label: el.label || el.topicName || el.skillTopicName,
                      value: el.value || el.topicId || el.skillTopicId,
                    })) || []
                  }
                  value={selectedTopic}
                  onChange={(e) => setSelectedTopic(e)}
                  onCreateOption={(inputValue) => {
                    setSelectedTopic({
                      label: inputValue,
                      value: 0,
                      __isNew__: true,
                    });
                  }}
                  isDisabled={
                    (isCreateMode && !selectedKnowledgeArea) || isViewMode
                  }
                />
              </div>
            </Stack>
          </div>
        </div>
        <Stack spacing={5}>
          <div className="form-group mt-3">
            <label className="labeltext px-0">Question Name*</label>
            <input
              type="text"
              required
              value={questionTitle}
              maxLength={200}
              className="form-control mt-1"
              onChange={(e) => {
                setQuestionTitle(e.target.value);
              }}
              disabled={isViewMode}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <label className="labeltext px-0">Question Description*</label>
            <div className="row mb-2">
              <div className="col-12">
                <JoditEditor
                  config={{
                    ...joditConfig,
                    placeholder: questionDescription ? "" : "Start writing...",
                  }}
                  ref={descriptionEditorRef}
                  value={questionDescription}
                  onBlur={(newContent) => {
                    setQuestionDescription(newContent);
                    setQuestionDescriptionError("");
                  }}
                  isDisabled={isViewMode}
                />
                {questionDescriptionError && (
                  <small style={{ color: "red" }}>
                    {questionDescriptionError}
                  </small>
                )}
              </div>
            </div>
          </div>
          <Stack spacing={2}>
            <div>
              <label className="labeltext px-0">Programming Languages*</label>
            </div>
            <div className="mt-2">
              <Select
                isMulti={currentType === 7}
                placeholder="Select Languages"
                options={
                  codingLanguages
                    ?.filter(
                      (lang) =>
                        lang.category?.id === (currentType === 12 ? 2 : 1),
                    )
                    ?.map((el) => ({
                      label: el.displayLanguage,
                      value: el.id,
                    })) || []
                }
                value={programmingLanguages}
                onChange={(e) => {
                  if (currentType === 12) {
                    setProgrammingLanguages(e ? [e] : []);
                  } else {
                    setProgrammingLanguages(e || []);
                  }
                }}
                isDisabled={isViewMode}
              />
            </div>
          </Stack>
          <Stack spacing={2}>
            <div>
              <label className="labeltext px-0">Tags*</label>
            </div>
            <div className="mt-2">
              <CreatableSelect
                options={qTags}
                isMulti
                value={tags}
                placeholder="Enter tags"
                onChange={(e) => handleTags(e)}
                isDisabled={isViewMode}
              />
            </div>
          </Stack>
        </Stack>
        <br />
        <Box
          sx={{ flexGrow: 2, display: "flex", alignItems: "baseline", gap: 1 }}
        >
          <FormControl
            sx={{ m: 1, width: 250 }}
            variant="outlined"
            size="small"
          >
            <div>
              <label className="labeltext px-0">Time* (Minutes)</label>
              <input
                type="number"
                value={timeDuration}
                min={1}
                className="form-control mt-2"
                style={{ padding: 8 }}
                disabled={isViewMode}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "") {
                    setTimeDuration("");
                    return;
                  }

                  setTimeDuration(Number(val));
                }}
                onBlur={() => {
                  if (timeDuration === "" || timeDuration <= 0) {
                    setTimeDuration(1);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "-" || e.key === "e") {
                    e.preventDefault();
                  }
                }}
              />
            </div>
          </FormControl>
          <FormControl
            sx={{ m: 1, width: 250 }}
            variant="outlined"
            size="small"
          >
            <div>
              <label className="labeltext px-0">Score* (Marks)</label>
              <input
                type="number"
                value={questionWeightage}
                min={1}
                className="form-control mt-2"
                style={{ padding: 8 }}
                disabled={isViewMode}
                onChange={(e) => {
                  const val = e.target.value;

                  if (val === "") {
                    setQuestionWeightage("");
                    return;
                  }

                  setQuestionWeightage(Number(val));
                }}
                onBlur={() => {
                  if (questionWeightage === "" || questionWeightage <= 0) {
                    setQuestionWeightage(1);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "-" || e.key === "e") {
                    e.preventDefault();
                  }
                }}
              />
            </div>
          </FormControl>
        </Box>
        <Box
          sx={{ flexGrow: 2, display: "flex", alignItems: "baseline", gap: 1 }}
        >
          <FormControl
            sx={{ m: 1, width: 250 }}
            variant="outlined"
            size="small"
          >
            <div>
              <label className="labeltext px-0" id="level-simple-select-label">
                Difficulty* (Level)
              </label>
            </div>
            <div className="mt-2">
              <select
                defaultValue={0}
                labelId="level-simple-select-label"
                id="level-simple-select"
                className="form-control"
                value={selectDifficulty}
                onChange={(event) =>
                  handleSelectChange(UI_STRINGS.DIFFICULTY, event)
                }
                disabled={isViewMode}
              >
                {questionLevel?.map((option, i) => {
                  return (
                    <option key={i} value={option?.questionLevelID}>
                      {option?.questionLevelName}
                    </option>
                  );
                })}
              </select>
            </div>
          </FormControl>
        </Box>
        {/* Stubs */}
        <div className="coding-config-card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h6>Stubs</h6>
            <button className="link-btn" onClick={handleOpenStubModal}>
              + Generate code stub
            </button>
          </div>

          <div className="card-body center d-flex justify-content-center align-items-center">
            <button className="link-btn" onClick={handleOpenStubModal}>
              <img
                src="/images/edit-blue-icon.svg"
                alt=""
                width={15}
                height={15}
              />
              Edit or view generated code stub
            </button>
          </div>
        </div>

        {/* sample solutions */}
        <div className="coding-config-card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h6>Sample solutions</h6>
            <button className="link-btn" onClick={openAddSolution}>
              + Add new
            </button>
          </div>

          <div className="card-body center">
            {sampleSolutions.length === 0 ? (
              <div className="d-flex justify-content-center align-items-center">
                <p>Sample solutions for this problem. Please add one.</p>
              </div>
            ) : (
              sampleSolutions.map((s, i) => (
                <div
                  key={i}
                  className="d-flex justify-content-between align-items-center"
                  style={{ height: "55px", padding: "16px" }}
                >
                  <span>{s.language_label}</span>

                  <div className="ccqv2-menu-wrapper">
                    <img
                      src="/images/threedots-vertical.png"
                      alt=""
                      className="cursor-pointer"
                      onClick={() =>
                        setOpenMenuIndex(openMenuIndex === i ? null : i)
                      }
                    />

                    {openMenuIndex === i && (
                      <div className="ccqv2-menu" ref={solutionMenuRef}>
                        <div
                          className="ccqv2-menu-item"
                          onClick={() => openEditSolution(s, i)}
                        >
                          Edit
                        </div>
                        <div
                          className="ccqv2-menu-item danger"
                          onClick={() =>
                            setSampleSolutions(
                              sampleSolutions.filter((_, idx) => idx !== i),
                            )
                          }
                        >
                          Delete
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        {/* test cases */}
        <div className="coding-config-card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h6>Testcases</h6>
            <button className="link-btn" onClick={openAddTestcase}>
              + Add new
            </button>
          </div>
          <div className="card-body center">
            {testCasesV2.length === 0 ? (
              <div className="d-flex justify-content-center align-items-center">
                <p>
                  Testcases define how the solution is evaluated. Please add
                  one.
                </p>
              </div>
            ) : (
              testCasesV2.map((t, i) => (
                <div
                  key={i}
                  className="d-flex justify-content-between align-items-center"
                  style={{ height: "55px", padding: "16px" }}
                >
                  <span>{t.name}</span>
                  <div className="ccqv2-menu-wrapper">
                    <img
                      src="/images/threedots-vertical.png"
                      alt=""
                      className="cursor-pointer"
                      onClick={() =>
                        setOpenTestCaseIndex(openTestCaseIndex === i ? null : i)
                      }
                    />

                    {openTestCaseIndex === i && (
                      <div className="ccqv2-menu" ref={testCaseMenuRef}>
                        <div
                          className="ccqv2-menu-item"
                          onClick={() => openEditTestcase(t, i)}
                        >
                          Edit
                        </div>
                        <div
                          className="ccqv2-menu-item danger"
                          onClick={() =>
                            setTestCasesV2(
                              testCasesV2.filter((_, idx) => idx !== i),
                            )
                          }
                        >
                          Delete
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      <div className="d-flex gap-3">
        {currentType !== 13 && (
           <button
              style={save_button_style}
              onClick={() => {
                if (location?.state?.view) {
                  const id = location?.state?.detail?.id;
                  if (id) {
                    window.open(`/try-coding/${id}`, "_blank");
                  }
                } else {
                  questionSaveHandler();
                }
              }}
              disabled={loading}
            >
            {location?.state?.view ? 'Try this problem' : 'Save & Try'}
          </button>
        )}
      {!location?.state?.view && (
          <div style={{ textAlign: "start", paddingLeft: "12px" }}>
            {" "}
            <button
              style={save_button_style}
              disabled={loading}
              onClick={() => questionSaveHandler()}
            >
              Save
            </button>
          </div>
      )}
      </div>
      {(location?.state?.view || location?.state?.edit) && (
        <Dialog
          className="screen-loader"
          open={loadingCodingQuestionById}
          onClose={() => {}}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          Loading ...
        </Dialog>
      )}

      {/* stub popup */}
      <Modal
        show={openStubModal}
        size="xl"
        centered
        className="codingQuestion-modal"
      >
        <div className="modal-header">
          <div></div>
          <h5 className="modal-title">Auto code stub generator</h5>
          <div
            className="sticky-close cursor-pointer"
            onClick={() => setOpenStubModal(false)}
          >
            <img src="/images/close-icon.svg" width="24" height="24" alt="" />
          </div>
        </div>

        <Modal.Body>
          <div className="row">
            {/* LEFT */}
            <div className="col-md-6">
              <label>Function name*</label>
              <input
                className="form-control"
                value={stubConfig.function_name}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.includes(" ")) {
                    returnErrors(
                      dispatch,
                      "Function name cannot contain spaces!",
                      500,
                    );
                    return;
                  }

                  setStubConfig({
                    ...stubConfig,
                    function_name: value,
                  });
                }}
                onKeyDown={(e) => {
                  if (e.key === " ") {
                    e.preventDefault();
                    returnErrors(
                      dispatch,
                      "Function name cannot contain spaces!",
                      500,
                    );
                  }
                }}
              />

              <label className="mt-3">Return type*</label>
              <select
                className="form-control"
                value={stubConfig.function_return_type ?? ""}
                onChange={(e) =>
                  setStubConfig({
                    ...stubConfig,
                    function_return_type: e.target.value
                      ? Number(e.target.value)
                      : null,
                  })
                }
              >
                <option value="">Select return type</option>
                {codingQuestionDataTypesOptions?.dataTypes?.map((rt) => (
                  <option key={rt.id} value={rt.id}>
                    {rt.name}
                  </option>
                ))}
              </select>

              {/* Parameters */}
              <label className="mt-3">Function parameters</label>

              {stubConfig.function_params.map((p, i) => (
                <div key={i} className="d-flex gap-2 mt-2">
                  <input
                    className="form-control"
                    placeholder="Parameter name"
                    value={p.name}
                    onChange={(e) => {
                      const copy = [...stubConfig.function_params];
                      copy[i].name = e.target.value;
                      setStubConfig({ ...stubConfig, function_params: copy });
                    }}
                  />
                  <select
                    class="form-control"
                    value={p.data_type ?? ""}
                    onChange={(e) => {
                      const copy = [...stubConfig.function_params];
                      copy[i].data_type = e.target.value
                        ? Number(e.target.value)
                        : null;

                      setStubConfig({
                        ...stubConfig,
                        function_params: copy,
                      });
                    }}
                  >
                    <option value="">Select type</option>
                    {codingQuestionDataTypesOptions?.dataTypes?.map((rt) => (
                      <option key={rt.id} value={rt.id}>
                        {rt.name}
                      </option>
                    ))}
                  </select>
                  <img
                    src="/images/delete-red.svg"
                    alt=""
                    className="cursor-pointer"
                    onClick={() => {
                      const copy = [...stubConfig.function_params];
                      copy.splice(i, 1);
                      setStubConfig({ ...stubConfig, function_params: copy });
                    }}
                  />
                </div>
              ))}

              <button
                className="link-btn mt-2"
                onClick={() =>
                  setStubConfig({
                    ...stubConfig,
                    function_params: [
                      ...stubConfig.function_params,
                      { name: "", data_type: "" },
                    ],
                  })
                }
              >
                Add parameter
              </button>
            </div>

            {/* RIGHT */}
            <div className="col-md-6">
              <label>Language</label>
              <select
                className="form-control"
                value={stubLanguage ?? ""}
                onChange={(e) =>
                  setStubLanguage(
                    e.target.value ? Number(e.target.value) : null,
                  )
                }
              >
                <option value="">Select language</option>
                {codingLanguages
                  .filter((l) => l.category?.id === 1)
                  .map((l) => (
                    <option key={l.id} value={l.id}>
                      {l.displayLanguage}
                    </option>
                  ))}
              </select>

              <label className="mt-3">Head</label>
              <StubAceEditor
                key={`head-${stubEditorVersion}`}
                mode={aceMode}
                defaultValue={stubHeadRef.current}
                height="100px"
                onChange={(val) => {
                  stubHeadRef.current = val;
                }}
              />

              <label className="mt-3">Body</label>
              <StubAceEditor
                key={`body-${stubEditorVersion}`}
                mode={aceMode}
                defaultValue={stubBodyRef.current}
                height="170px"
                onChange={(val) => {
                  stubBodyRef.current = val;
                }}
              />

              <label className="mt-3">Tail</label>
              <StubAceEditor
                key={`tail-${stubEditorVersion}`}
                mode={aceMode}
                defaultValue={stubTailRef.current}
                height="100px"
                onChange={(val) => {
                  stubTailRef.current = val;
                }}
              />
            </div>
          </div>

          <div className="action-buttons d-flex justify-content-end gap-2 mt-4">
            <button
              className="cancel-btn"
              onClick={handleGenerateStub}
              disabled={isGeneratingStub}
              style={{
                backgroundColor: isGeneratingStub ? "#B0B0B0" : "",
                cursor: isGeneratingStub ? "not-allowed" : "pointer",
              }}
            >
              {isGeneratingStub ? "Generating..." : "Generate stub"}
            </button>
            <button onClick={saveStub}>Save</button>
          </div>
        </Modal.Body>
      </Modal>

      {/* sample solution popup */}
      <Modal
        show={openSolutionModal}
        size="md"
        centered
        className="codingQuestion-modal"
      >
        <div className="modal-header">
          <div></div>
          <h5 className="modal-title">Add a sample solution</h5>
          <div
            className="sticky-close cursor-pointer"
            onClick={() => setOpenSolutionModal(false)}
          >
            <img src="/images/close-icon.svg" width="24" height="24" alt="" />
          </div>
        </div>

        <Modal.Body>
          <label>Select technology</label>
          <Select
            placeholder="Select technology"
            options={codingLanguages
              ?.filter((l) => l?.category?.id === 1)
              .map((l) => ({
                label: l.displayLanguage,
                value: l.id,
              }))}
            value={solutionLanguage}
            onChange={(e) => setSolutionLanguage(e)}
          />

          <label className="mt-3">Solution</label>
          <AceEditor
            key={`solution-${solutionEditorVersion}`}
            mode={aceMode}
            theme="github"
            defaultValue={solutionEditorRef.current}
            width="100%"
            height="200px"
            fontSize={14}
            showPrintMargin={false}
            setOptions={{
              useWorker: false,
              showLineNumbers: true,
              tabSize: 2,
            }}
            onChange={(val) => {
              solutionEditorRef.current = val;
            }}
          />

          <div className="action-buttons d-flex justify-content-end gap-2 mt-4">
            <button
              className="cancel-btn"
              onClick={() => setOpenSolutionModal(false)}
            >
              Cancel
            </button>
            <button onClick={saveSolution}>Save</button>
          </div>
        </Modal.Body>
      </Modal>

      {/* test case popup */}
      <Modal
        show={openTestcaseModal}
        size="md"
        centered
        className="codingQuestion-modal"
      >
        <div className="modal-header">
          <div></div>
          <h5 className="modal-title">Add new testcase</h5>
          <div
            className="sticky-close cursor-pointer"
            onClick={() => setOpenTestcaseModal(false)}
          >
            <img src="/images/close-icon.svg" width="24" height="24" alt="" />
          </div>
        </div>

        <Modal.Body>
          <label>Testcase input</label>
          <textarea
            className="form-control"
            ref={tcInputRef}
            value={tcInput}
            placeholder="Testcase input"
            style={{
              width: "100%",
              minHeight: "20px",
              resize: "none",
              overflow: "hidden",
              border: "none",
              borderBottom: "1px solid #ced4da",
              borderRadius: "0",
            }}
            onChange={(e) => {
              setTcInput(e.target.value);
              autoResize(e.target);
            }}
            onInput={(e) => autoResize(e.target)}
          />

          <label className="mt-3">Testcase output</label>
          <textarea
            className="form-control"
            ref={tcOutputRef}
            value={tcOutput}
            placeholder="Expected output"
            style={{
              width: "100%",
              minHeight: "20px",
              resize: "none",
              overflow: "hidden",
              border: "none",
              borderBottom: "1px solid #ced4da",
              borderRadius: "0",
            }}
            onChange={(e) => {
              setTcOutput(e.target.value);
              autoResize(e.target);
            }}
            onInput={(e) => autoResize(e.target)}
          />

          <label className="mt-3">Testcase weightage</label>
          <div className="d-flex align-items-center gap-3">
            <input
              type="range"
              min={1}
              max={5}
              value={tcWeight}
              onChange={(e) => setTcWeight(Number(e.target.value))}
            />
            <input
              readOnly
              className="form-control mt-1"
              value={tcWeight}
              style={{ width: "40px" }}
            />
          </div>

          <div className="form-check mt-3 d-flex align-items-center gap-2">
            <input
              type="checkbox"
              className="form-check-input"
              checked={tcIsSample}
              disabled={
                !tcIsSample &&
                testCasesV2.some((t, idx) => t.is_sample && idx !== tcEditIndex)
              }
              onChange={(e) => setTcIsSample(e.target.checked)}
              style={{
                width: "20px",
                height: "20px",
                border: "1px solid #d7dadb",
              }}
            />
            <label className="form-check-label m-0">Is sample testcase?</label>
          </div>

          <div className="action-buttons d-flex justify-content-end gap-2 mt-4">
            <button
              className="cancel-btn"
              onClick={() => setOpenTestcaseModal(false)}
            >
              Cancel
            </button>
            <button onClick={saveTestcase}>Add test case</button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CreateCodingQuestionv2;
